export default {
    methods: {
        convertArrayToGallery(array) {
            let albums = {};

            if (!Array.isArray(array)) {
                return [];
            }

            array.forEach(photo => {
                let properties = photo.custom_properties;

                const photoObj = {...photo, ...{title: properties.title}};

                if (albums.hasOwnProperty(properties.uuid)) {
                    albums[properties.uuid].photos.push(photoObj);
                } else {
                    albums[properties.uuid] = {
                        nameAlbum: properties.nameAlbum,
                        photos: [photoObj],
                        uuid: properties.uuid
                    };
                }
            });

            return Object.values(albums).map(album => {
                    album.photos = album.photos.sort(this.compareFnForPhotos);
                    return album;
                });
        },
        convertGalleryToArray(gallery) {
            let array = [];

            gallery.forEach(album => {
                album.photos.forEach(photo => {
                    photo.custom_properties = {
                        ...photo.custom_properties,
                        ...{
                            nameAlbum: album.nameAlbum,
                            uuid: album.uuid,
                            title: photo.title
                        }
                    };

                    array.push(photo);
                });
            });

            return array;
        },
        compareFnForPhotos(photoA, photoB) {
            const positionA = photoA.custom_properties.position;
            const positionB = photoB.custom_properties.position;

            if (positionA < positionB) {
                return -1;
            }

            if (positionA > positionB) {
                return 1;
            }

            return 0;
        },
        getFirstChar(link) {
            if (link && link.length) {
                link = link.replace(/(https?:\/\/)?(www.)?/g, '');

                return link.charAt(0);
            }
        },
    }
}
